// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./browser/Browser__Tabs.bs.js");
var DevProtocol__CSS$SmartcutsMacros = require("./devProtocol/DevProtocol__CSS.bs.js");
var DevProtocol__DOM$SmartcutsMacros = require("./devProtocol/DevProtocol__DOM.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var DevProtocol__DOMHelpers$SmartcutsMacros = require("./devProtocol/DevProtocol__DOMHelpers.bs.js");

function getCurrentUrl(param) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                return OptionUtils$SmartcutsMacros.getExn("Expect to get Some(url) when getCurrentUrl() in Background", param.url);
              }), Browser__Tabs$SmartcutsMacros.get(param.tabId));
}

function getNodeIdBackendNodeIdPairsForNodeIds(tabId, nodeIds) {
  return Promise.all($$Array.map((function (nodeId) {
                      return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeNode) {
                                  return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, (function (node) {
                                                    return [
                                                            nodeId,
                                                            node.backendNodeId
                                                          ];
                                                  })));
                                });
                    }), nodeIds)).then(function (maybeElements) {
              return Promise.resolve(ArrayUtils$SmartcutsMacros.filterMap((function (a) {
                                return a;
                              }), maybeElements));
            });
}

function querySelectorAll(context, queryRoot, maybeDomTree, _includeElementsNotVisible, selectorExpression) {
  var tabId = context.tabId;
  var query = function (param) {
    return DevProtocol__DOM$SmartcutsMacros.querySelectorAll(param[0], selectorExpression, tabId, undefined, undefined, undefined).then(function (param) {
                return getNodeIdBackendNodeIdPairsForNodeIds(tabId, param);
              });
  };
  if (typeof queryRoot === "number") {
    return (
              maybeDomTree !== undefined ? Promise.resolve(Caml_option.some(Caml_option.valFromOption(maybeDomTree))) : DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined)
            ).then(function (maybeDocument) {
                if (maybeDocument === undefined) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* CdpUnableToGetDocument */1
                            });
                }
                var rootNode = Caml_option.valFromOption(maybeDocument);
                return PromiseUtils$SmartcutsMacros.map(query([
                                rootNode.nodeId,
                                rootNode.backendNodeId
                              ]), (function (element) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: element
                                    };
                            }));
              });
  } else if (queryRoot.TAG === /* Element */0) {
    return PromiseUtils$SmartcutsMacros.map(query(queryRoot._0), (function (element) {
                  return {
                          TAG: /* Ok */0,
                          _0: element
                        };
                }));
  } else {
    return PromiseUtils$SmartcutsMacros.map(query(queryRoot._0), (function (element) {
                  return {
                          TAG: /* Ok */0,
                          _0: element
                        };
                }));
  }
}

function isJsExnNodeIdFailure(jsExn) {
  var message = jsExn.message;
  var maybeErrorCode;
  if (message !== undefined) {
    try {
      maybeErrorCode = Json_decode.field("code", Json_decode.$$int, JSON.parse(message));
    }
    catch (exn){
      maybeErrorCode = undefined;
    }
  } else {
    maybeErrorCode = undefined;
  }
  return Caml_obj.caml_equal(maybeErrorCode, -32000);
}

function shouldRetryForJsPromiseError(queryRoot, jsPromiseError) {
  var jsPromiseError$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
  var exit = 0;
  var jsExn;
  if (typeof jsPromiseError$1 === "number") {
    if (jsPromiseError$1 === /* PromiseCanceled */1) {
      return false;
    }
    
  } else {
    switch (jsPromiseError$1.TAG | 0) {
      case /* JsExn */0 :
          jsExn = jsPromiseError$1._0;
          exit = 2;
          break;
      case /* WaitForPredicateError */9 :
          var jsExn$1 = jsPromiseError$1._0;
          if (typeof jsExn$1 !== "number" && jsExn$1.TAG === /* JsExn */0) {
            jsExn = jsExn$1._0;
            exit = 2;
          }
          break;
      case /* UnknownPromiseError */13 :
          console.warn("Unknown promise error", jsPromiseError$1._0);
          return false;
      default:
        
    }
  }
  if (exit === 2 && isJsExnNodeIdFailure(jsExn)) {
    console.warn("NodeId or compute box model error", jsExn);
    var match = jsExn.message;
    if (match === "{\"code\":-32000,\"message\":\"Could not compute box model.\"}") {
      return true;
    } else {
      return queryRoot === /* Document */0;
    }
  }
  console.warn("Other js promise error", jsPromiseError);
  return false;
}

function queryXPath(param, param$1, addCancelCallback, xpath) {
  var tabId = param.tabId;
  return DevProtocol__DOM$SmartcutsMacros.enable(tabId, undefined, undefined, undefined).then(function (param) {
                return DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined).then(function (param) {
                              var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                                    if (isCanceled.contents) {
                                      throw {
                                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                            Error: new Error()
                                          };
                                    }
                                    return DevProtocol__DOM$SmartcutsMacros.performSearch(tabId, undefined, undefined, true, xpath, undefined);
                                  });
                              Curry._1(addCancelCallback, match[1]);
                              return Curry._1(match[0], undefined);
                            }).then(function (maybeResult) {
                            if (maybeResult === undefined) {
                              return Promise.resolve([]);
                            }
                            var resultCount = maybeResult.resultCount;
                            if (resultCount === 0) {
                              return Promise.resolve([]);
                            }
                            var searchId = maybeResult.searchId;
                            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                                  if (isCanceled.contents) {
                                    throw {
                                          RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                          Error: new Error()
                                        };
                                  }
                                  return DevProtocol__DOM$SmartcutsMacros.getSearchResults(tabId, undefined, undefined, searchId, 0, resultCount, undefined);
                                });
                            Curry._1(addCancelCallback, match[1]);
                            return Curry._1(match[0], undefined).then(function (maybeResult) {
                                        if (maybeResult !== undefined) {
                                          return Promise.resolve(maybeResult.nodeIds);
                                        } else {
                                          return Promise.resolve([]);
                                        }
                                      });
                          });
              }).then(function (nodeIds) {
              var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                    if (isCanceled.contents) {
                      throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                          };
                    }
                    return getNodeIdBackendNodeIdPairsForNodeIds(tabId, nodeIds);
                  });
              Curry._1(addCancelCallback, match[1]);
              return Curry._1(match[0], undefined);
            });
}

function getTagName(param, param$1) {
  return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, param$1[1], undefined, undefined, undefined, param.tabId, undefined, undefined, undefined).then(function (maybeNode) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, (function (prim) {
                                return prim.nodeName;
                              })));
            });
}

function couldElementMatchSelectorTreeNode(context, element, node) {
  return getTagName(context, element).then(function (maybeTagName) {
              return Promise.resolve(Caml_obj.caml_equal(OptionUtils$SmartcutsMacros.map(maybeTagName, $$String.lowercase_ascii), node.tagName));
            });
}

function isVisibleOnPage(param, param$1) {
  return DevProtocol__DOMHelpers$SmartcutsMacros.getBoxModel(undefined, param$1[1], undefined, param.tabId, undefined, undefined, undefined).then(function (maybeBoxModel) {
                if (maybeBoxModel !== undefined) {
                  return Promise.resolve(!(maybeBoxModel.width === 0 && maybeBoxModel.height === 0));
                } else {
                  return Promise.resolve(false);
                }
              }).catch(function (jsPromiseError) {
              var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
              if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */0 && Caml_obj.caml_equal(jsExn._0.message, "{\"code\":-32000,\"message\":\"Could not compute box model.\"}"))) {
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
              } else {
                return Promise.resolve(false);
              }
            });
}

function getInnerTextForNode(tabId, addCancelCallback, node) {
  if (node.nodeName === "#text") {
    return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (addCancelCallback) {
                  var nonZeroNodeId = node.nodeId;
                  return (
                              nonZeroNodeId !== 0 ? Promise.resolve(nonZeroNodeId) : DevProtocol__DOMHelpers$SmartcutsMacros.getNodeIdFromBackendNodeId(tabId, node.backendNodeId, addCancelCallback).then(function (maybeNodeId) {
                                      return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(0, maybeNodeId));
                                    })
                            ).then(function (nodeId) {
                                return DevProtocol__DOMHelpers$SmartcutsMacros.isNodeVisible(tabId, addCancelCallback, nodeId);
                              }).then(function (isVisible) {
                              return Promise.resolve(isVisible ? node.nodeValue : "");
                            });
                }));
  }
  var children = node.children;
  if (children !== undefined) {
    return Promise.all(Belt_Array.map(children, (function (param) {
                        return getInnerTextForNode(tabId, addCancelCallback, param);
                      }))).then(function (innerTexts) {
                return Promise.resolve(innerTexts.join(""));
              });
  } else {
    return Promise.resolve("");
  }
}

function fetchDomTree(param, addCancelCallback) {
  var tabId = param.tabId;
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return DevProtocol__DOM$SmartcutsMacros.getDocument(/* EntireSubTree */0, true, tabId, undefined, undefined, undefined);
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function getParentElement(domTree, param) {
  var arg = DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, param[1]);
  var param$1 = function (parentNode) {
    var match = parentNode.nodeName;
    switch (match) {
      case "#document" :
      case "HTML" :
          return ;
      default:
        return [
                parentNode.nodeId,
                parentNode.backendNodeId
              ];
    }
  };
  return OptionUtils$SmartcutsMacros.andThen(param$1, arg);
}

function getParentChainInner($staropt$star, domTree, element) {
  var backendNodeId = element[1];
  var chain = $staropt$star !== undefined ? $staropt$star : [];
  if (domTree.backendNodeId === backendNodeId) {
    return $$Array.append(chain, [element]);
  }
  var match = domTree.children;
  var match$1 = domTree.shadowRoots;
  var exit = 0;
  var childrenNodes;
  var shadowRoots;
  if (match !== undefined) {
    var exit$1 = 0;
    if (match.length !== 0) {
      exit$1 = 3;
    } else {
      if (match$1 === undefined) {
        return ;
      }
      if (match$1.length === 0) {
        return ;
      }
      exit$1 = 3;
    }
    if (exit$1 === 3) {
      if (match$1 !== undefined && match$1.length !== 0) {
        if (match.length !== 0) {
          var fullChain = Util$SmartcutsMacros.shortcut((function (subTree) {
                  var match = domTree.nodeName;
                  var nextChain;
                  switch (match) {
                    case "#document" :
                    case "HTML" :
                    case "html" :
                        nextChain = chain;
                        break;
                    default:
                      nextChain = $$Array.append(chain, [[
                              domTree.nodeId,
                              domTree.backendNodeId
                            ]]);
                  }
                  return getParentChainInner(nextChain, subTree, element);
                }), match$1);
          if (fullChain !== undefined) {
            return fullChain;
          } else {
            return Util$SmartcutsMacros.shortcut((function (subTree) {
                          var match = domTree.nodeName;
                          var nextChain;
                          switch (match) {
                            case "#document" :
                            case "HTML" :
                            case "html" :
                                nextChain = chain;
                                break;
                            default:
                              nextChain = $$Array.append(chain, [[
                                      domTree.nodeId,
                                      domTree.backendNodeId
                                    ]]);
                          }
                          return getParentChainInner(nextChain, subTree, element);
                        }), match);
          }
        }
        shadowRoots = match$1;
        exit = 2;
      } else {
        childrenNodes = match;
        exit = 1;
      }
    }
    
  } else {
    if (match$1 === undefined) {
      return ;
    }
    if (match$1.length === 0) {
      return ;
    }
    shadowRoots = match$1;
    exit = 2;
  }
  switch (exit) {
    case 1 :
        return Util$SmartcutsMacros.shortcut((function (subTree) {
                      var match = domTree.nodeName;
                      var nextChain;
                      switch (match) {
                        case "#document" :
                        case "HTML" :
                        case "html" :
                            nextChain = chain;
                            break;
                        default:
                          nextChain = $$Array.append(chain, [[
                                  domTree.nodeId,
                                  domTree.backendNodeId
                                ]]);
                      }
                      return getParentChainInner(nextChain, subTree, element);
                    }), childrenNodes);
    case 2 :
        if (Belt_Array.some(shadowRoots, (function (shadowRoot) {
                  return shadowRoot.backendNodeId === backendNodeId;
                }))) {
          return chain;
        } else {
          return Util$SmartcutsMacros.shortcut((function (subTree) {
                        var match = domTree.nodeName;
                        var nextChain;
                        switch (match) {
                          case "#document" :
                          case "HTML" :
                          case "html" :
                              nextChain = chain;
                              break;
                          default:
                            nextChain = $$Array.append(chain, [[
                                    domTree.nodeId,
                                    domTree.backendNodeId
                                  ]]);
                        }
                        return getParentChainInner(nextChain, subTree, element);
                      }), shadowRoots);
        }
    
  }
}

function getParentChain(domTree, element) {
  var arg = getParentChainInner([], domTree, element);
  var param = [];
  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}

function getParentElements(domTree, elements) {
  return $$Array.map((function (maybeParent) {
                return OptionUtils$SmartcutsMacros.map(maybeParent, (function (parentNode) {
                              return [
                                      parentNode.nodeId,
                                      parentNode.backendNodeId
                                    ];
                            }));
              }), $$Array.map((function (param) {
                    return DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, param[1]);
                  }), elements));
}

function getSiblingIndex(domTree, param) {
  var backendNodeId = param[1];
  var parentNode = DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, backendNodeId);
  if (parentNode === undefined) {
    return 1;
  }
  var arg = Caml_option.valFromOption(parentNode).children;
  var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
  var arg$2 = Belt_Array.getIndexBy((function (param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
          })([]), (function (childNode) {
          return childNode.backendNodeId === backendNodeId;
        }));
  return 1 + (function (param) {
              return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
            })(0) | 0;
}

function describeNode(domTree, backendNodeId) {
  if (domTree.backendNodeId === backendNodeId) {
    return Caml_option.some(domTree);
  }
  var match = domTree.children;
  var match$1 = domTree.shadowRoots;
  var exit = 0;
  var childrenNodes;
  var shadowRoots;
  if (match !== undefined) {
    var exit$1 = 0;
    if (match.length !== 0) {
      exit$1 = 3;
    } else {
      if (match$1 === undefined) {
        return ;
      }
      if (match$1.length === 0) {
        return ;
      }
      exit$1 = 3;
    }
    if (exit$1 === 3) {
      if (match$1 !== undefined && match$1.length !== 0) {
        if (match.length !== 0) {
          var matchingNode = Belt_Array.getBy(match$1, (function (subTree) {
                  return subTree.backendNodeId === backendNodeId;
                }));
          if (matchingNode !== undefined) {
            return Caml_option.some(Caml_option.valFromOption(matchingNode));
          }
          var matchingNode$1 = Belt_Array.getBy(match, (function (subTree) {
                  return subTree.backendNodeId === backendNodeId;
                }));
          if (matchingNode$1 !== undefined) {
            return Caml_option.some(Caml_option.valFromOption(matchingNode$1));
          }
          var matchingNode$2 = Util$SmartcutsMacros.shortcut((function (subTree) {
                  return describeNode(subTree, backendNodeId);
                }), match$1);
          if (matchingNode$2 !== undefined) {
            return Caml_option.some(Caml_option.valFromOption(matchingNode$2));
          }
          var matchingNode$3 = Util$SmartcutsMacros.shortcut((function (subTree) {
                  return describeNode(subTree, backendNodeId);
                }), match);
          if (matchingNode$3 !== undefined) {
            return Caml_option.some(Caml_option.valFromOption(matchingNode$3));
          } else {
            return ;
          }
        }
        shadowRoots = match$1;
        exit = 2;
      } else {
        childrenNodes = match;
        exit = 1;
      }
    }
    
  } else {
    if (match$1 === undefined) {
      return ;
    }
    if (match$1.length === 0) {
      return ;
    }
    shadowRoots = match$1;
    exit = 2;
  }
  switch (exit) {
    case 1 :
        return Util$SmartcutsMacros.shortcut((function (subTree) {
                      return describeNode(subTree, backendNodeId);
                    }), childrenNodes);
    case 2 :
        return Util$SmartcutsMacros.shortcut((function (subTree) {
                      return describeNode(subTree, backendNodeId);
                    }), shadowRoots);
    
  }
}

function getDomShadowRoot(domTree, param) {
  var arg = describeNode(domTree, param[1]);
  var param$1 = function (cdpDomNode) {
    var arg = cdpDomNode.shadowRoots;
    var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
    return OptionUtils$SmartcutsMacros.map((function (param) {
                    return OptionUtils$SmartcutsMacros.andThen(param, arg$1);
                  })(function (shadowRoots) {
                    return Belt_Array.get(shadowRoots, 0);
                  }), (function (cdpDomNode) {
                  return [
                          cdpDomNode.nodeId,
                          cdpDomNode.backendNodeId
                        ];
                }));
  };
  return OptionUtils$SmartcutsMacros.andThen(param$1, arg);
}

function getElementFromDomTreeByBackendNodeId(domTree, backendNodeId) {
  var arg = describeNode(domTree, backendNodeId);
  return [
          (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("Expect to find node with backendNodeId when getElementFromDomTreeByBackendNodeId()").nodeId,
          backendNodeId
        ];
}

function getElementAttributes(domTree, param) {
  var node = describeNode(domTree, param[1]);
  if (node === undefined) {
    return ;
  }
  var arg = OptionUtils$SmartcutsMacros.map(Caml_option.undefined_to_opt(Caml_option.valFromOption(node).attributes), (function (attributes) {
          return Belt_MapString.fromArray(ArrayUtils$SmartcutsMacros.groupIntoPairs(attributes));
        }));
  var param$1;
  return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}

function idFromAttributes(attributes) {
  return Belt_MapString.get(attributes, "id");
}

function classNamesFromAttributes(attributes) {
  var arg = OptionUtils$SmartcutsMacros.map(Belt_MapString.get(attributes, "class"), (function (attr) {
          return Belt_Array.keepMap(attr.split(/\n+/), (function (x) {
                        return x;
                      }));
        }));
  var param = [];
  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}

function keepAttributes(f, attributes) {
  return Belt_MapString.fromArray(Belt_Array.keep(Belt_MapString.toArray(attributes), (function (param) {
                    return Curry._2(f, param[0], param[1]);
                  })));
}

function getUpdatedElementFromDomTree(domTree, param) {
  return getElementFromDomTreeByBackendNodeId(domTree, param[1]);
}

function getNthParent(domTree, nth, element) {
  var backendNodeIdOfNthParent = function (nth, domTree, backendNodeId) {
    if (nth === 0) {
      return backendNodeId;
    } else {
      return Belt_Option.flatMap(DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, backendNodeId), (function (node) {
                    var arg = node.backendNodeId;
                    var param = nth - 1 | 0;
                    return backendNodeIdOfNthParent(param, domTree, arg);
                  }));
    }
  };
  if (nth === 0) {
    return element;
  }
  var func = function (param, param$1) {
    return backendNodeIdOfNthParent(nth, param, param$1);
  };
  return Belt_Option.map(Curry._2(func, domTree, element[1]), (function (param) {
                return getElementFromDomTreeByBackendNodeId(domTree, param);
              }));
}

function getInnerTextForElement(param, addCancelCallback, param$1) {
  var backendNodeId = param$1[1];
  var nodeId = param$1[0];
  var tabId = param.tabId;
  return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (addCancelCallback) {
                return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, backendNodeId, undefined, /* EntireSubTree */0, false, tabId, undefined, undefined, undefined).then(function (maybeNode) {
                            if (maybeNode !== undefined) {
                              return getInnerTextForNode(tabId, addCancelCallback, Caml_option.valFromOption(maybeNode)).then(function (innerText) {
                                          var trimmedInnerText = innerText.trim();
                                          return Promise.resolve(trimmedInnerText === "" ? /* NoInnerText */1 : ({
                                                          TAG: /* FullInnerText */0,
                                                          _0: trimmedInnerText
                                                        }));
                                        });
                            } else {
                              return Util$SmartcutsMacros.logAndRaiseJsError("Couldn't find node: " + String(nodeId));
                            }
                          });
              }));
}

function isElementEqualTo(param, param$1) {
  return param[1] === param$1[1];
}

function getScrollHeight(param, param$1) {
  return DevProtocol__DOMHelpers$SmartcutsMacros.getScrollHeight(param.tabId, param$1[1]).then(function (maybeScrollHeight) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expect to get Some(scrollHeight) for an element", maybeScrollHeight) | 0);
            });
}

function getClientHeight(param, param$1) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (maybeClientHeight) {
                return OptionUtils$SmartcutsMacros.withDefault(0, maybeClientHeight);
              }), DevProtocol__DOMHelpers$SmartcutsMacros.getClientHeight(param.tabId, param$1[0]));
}

function getOverflowYForElement(param, param$1) {
  var nodeId = param$1[0];
  var tabId = param.tabId;
  return DevProtocol__CSS$SmartcutsMacros.enable(tabId, undefined, undefined, undefined).then(function (param) {
              return DevProtocol__CSS$SmartcutsMacros.getComputedStyleForNode(nodeId, tabId, undefined, undefined, undefined).then(function (maybeStyles) {
                          var styles = OptionUtils$SmartcutsMacros.withDefault([], maybeStyles);
                          var match = Belt_Array.getBy(styles, (function (param) {
                                  return param.name === "overflowY";
                                }));
                          if (match !== undefined) {
                            return Promise.resolve(match.value);
                          } else {
                            return Promise.resolve("");
                          }
                        });
            });
}

function scrollTo(param, x, y, param$1) {
  return DevProtocol__DOMHelpers$SmartcutsMacros.scrollTo(param.tabId, param$1[0], x, y, undefined);
}

var maxRetries = 3;

exports.getCurrentUrl = getCurrentUrl;
exports.querySelectorAll = querySelectorAll;
exports.maxRetries = maxRetries;
exports.shouldRetryForJsPromiseError = shouldRetryForJsPromiseError;
exports.queryXPath = queryXPath;
exports.getTagName = getTagName;
exports.couldElementMatchSelectorTreeNode = couldElementMatchSelectorTreeNode;
exports.isVisibleOnPage = isVisibleOnPage;
exports.fetchDomTree = fetchDomTree;
exports.getParentElement = getParentElement;
exports.getParentChainInner = getParentChainInner;
exports.getParentChain = getParentChain;
exports.getParentElements = getParentElements;
exports.getSiblingIndex = getSiblingIndex;
exports.getDomShadowRoot = getDomShadowRoot;
exports.getElementAttributes = getElementAttributes;
exports.idFromAttributes = idFromAttributes;
exports.classNamesFromAttributes = classNamesFromAttributes;
exports.keepAttributes = keepAttributes;
exports.getUpdatedElementFromDomTree = getUpdatedElementFromDomTree;
exports.getNthParent = getNthParent;
exports.getInnerTextForElement = getInnerTextForElement;
exports.isElementEqualTo = isElementEqualTo;
exports.getScrollHeight = getScrollHeight;
exports.getClientHeight = getClientHeight;
exports.getOverflowYForElement = getOverflowYForElement;
exports.scrollTo = scrollTo;
/* Util-SmartcutsMacros Not a pure module */
